module.exports = __webpack_public_path__ + "static/search1-f160629a805393a138e977f96627c5be.png";